import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import { replacePlaceholder } from './Placeholders';

const fontFamilies = [
  { name: 'Courier', value: 'Courier' },
  { name: 'Courier Bold', value: 'CourierBold' },
  { name: 'Courier Oblique', value: 'CourierOblique ' },
  { name: 'Courier BoldOblique', value: 'CourierBoldOblique' },
  { name: 'Helvetica', value: 'Helvetica' },
  { name: 'Helvetica Bold', value: 'HelveticaBold' },
  { name: 'Helvetica Oblique', value: 'HelveticaOblique' },
  { name: 'Helvetica BoldOblique', value: 'HelveticaBoldOblique' },
  { name: 'Times New Roman', value: 'TimesRoman' },
  { name: 'Times Bold', value: 'TimesRomanBold' },
  { name: 'Times Italic', value: 'TimesRomanItalic' },
  { name: 'Times BoldItalic', value: 'TimesRomanBoldItalic' }
];

const createPdf = async (width = 2480, height = 3508, items, images) => {
  try {
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([width, height]);

    items.sort((a, b) => a.zIndex - b.zIndex);

    const hexColorToRGB = (color) => {
      return [
        parseInt(color.slice(1,3), 16),
        parseInt(color.slice(3,5), 16),
        parseInt(color.slice(5,7), 16)
      ];
    };

    const addImage = async (item) => {
      if (!images[item.name]) return;
      const { mime_type, image: imageBase64 } = images[item.name];
      let image;
      try {
        if (mime_type == 'image/jpeg') {
          image = await pdfDoc.embedJpg(imageBase64);
        } else if (mime_type == 'image/png') {
          image = await pdfDoc.embedPng(imageBase64);
        } else {
          throw new Error('Image mime type not supported');
        }
      } catch (error) {
        console.log(error);
      }

      const { x, y } = item.coordinates;
      const { width: imageWidth, height: imageHeight } = image.size();
      const yTranslated = height - (y + imageHeight);
      const options = { x, y: yTranslated, imageWidth, imageHeight };
      page.drawImage(image, options);
    };

    const addText = async (item) => {
      const { size, color, width } = item;
      const font = fontFamilies.find(f => f.name == item.font).value;
      const { [font]: font2Embed } = StandardFonts;
      const currentFont = await pdfDoc.embedFont(font2Embed);
      const { x, y } = item.coordinates;
      const text = replacePlaceholder(item.text);
      const yTranslated = height - (y + size - 24);
      const [r, g, b] = hexColorToRGB(color);
      const colorRGB = [r/255, g/255, b/255];
      const options = {
        x,
        y: yTranslated,
        size: parseFloat(size),
        font: currentFont,
        maxWidth: parseFloat(width) + width/100,
        lineHeight: 1*size,
        color: rgb(colorRGB[0], colorRGB[1], colorRGB[2])
      };

      page.drawText(text.replaceAll('\n', ' \n'), options);
    };

    for await (let item of items) {
      item.type == 'image'
        ? await addImage(item)
        : await addText(item);
    }

    return pdfDoc.saveAsBase64({ dataUri: true});
  } catch (error) {
    console.log(error);
  }
};


export default createPdf;